'use strict'

module.exports = inlineCode

var u = require('unist-builder')

function inlineCode(h, node) {
  var value = node.value.replace(/\r?\n|\r/g, ' ')
  return h(node, 'code', [u('text', value)])
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/mdast-util-to-hast/lib/handlers/inline-code.js
// module id = Eqjs
// module chunks = 0